export function parseCroatianDate(value: string): string | null {
  const match = value.trim().match(/^(\d{1,2})\.(\d{1,2})\.(\d{4})\.?$/);
  if (!match) return null;
  const day = Number(match[1]);
  const month = Number(match[2]);
  const year = Number(match[3]);
  const date = new Date(Date.UTC(year, month - 1, day));
  if (
    date.getUTCFullYear() !== year ||
    date.getUTCMonth() !== month - 1 ||
    date.getUTCDate() !== day
  ) return null;
  return `${year.toString().padStart(4, '0')}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`;
}

export function parseCroatianDateTime(value: string): string | null {
  const match = value.trim().match(
    /^(\d{1,2})\.(\d{1,2})\.(\d{4})\.?\s+(\d{1,2}):(\d{2})$/
  );
  if (!match) return null;
  const date = parseCroatianDate(`${match[1]}.${match[2]}.${match[3]}.`);
  const hour = Number(match[4]);
  const minute = Number(match[5]);
  if (!date || hour > 23 || minute > 59) return null;
  return `${date}T${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}`;
}

export function formatDateValue(value: string | null | undefined): string {
  if (!value) return '';
  const dateOnly = value.slice(0, 10).match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (dateOnly) return `${dateOnly[3]}.${dateOnly[2]}.${dateOnly[1]}.`;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  return new Intl.DateTimeFormat('hr-HR', {
    day: '2-digit', month: '2-digit', year: 'numeric'
  }).format(date);
}

export function formatDateTimeValue(value: string | null | undefined): string {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  return new Intl.DateTimeFormat('hr-HR', {
    day: '2-digit', month: '2-digit', year: 'numeric',
    hour: '2-digit', minute: '2-digit'
  }).format(date);
}

export function toCroatianDateInput(value: string, withTime = false): string {
  if (!value) return '';
  if (!withTime) return formatDateValue(value);
  const match = value.match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})/);
  return match ? `${match[3]}.${match[2]}.${match[1]}. ${match[4]}:${match[5]}` : '';
}

export function formatTypedDate(raw: string, withTime = false): string {
  const digits = raw.replace(/\D/g, '').slice(0, withTime ? 12 : 8);
  const day = digits.slice(0, 2);
  const month = digits.slice(2, 4);
  const year = digits.slice(4, 8);
  const hour = digits.slice(8, 10);
  const minute = digits.slice(10, 12);
  let result = day;
  if (digits.length > 2) result += `.${month}`;
  if (digits.length > 4) result += `.${year}`;
  if (digits.length >= 8) result += '.';
  if (withTime && digits.length > 8) result += ` ${hour}`;
  if (withTime && digits.length > 10) result += `:${minute}`;
  return result;
}
